import React, { useEffect, useState } from 'react';
import { ADMIN_JOBS_COUNT_EVENT, getAdminJobsCount, openAdminJobs } from './events';

// The way back into "Jobs to do" after "Remind me tomorrow": a small button in
// the top bar, shown only while there are jobs. The count comes from the host
// in containers/App, which already asked.
export function AdminJobsButton() {
  const [count, setCount] = useState(getAdminJobsCount());

  useEffect(() => {
    const onCount = event => setCount(event.detail || 0);
    window.addEventListener(ADMIN_JOBS_COUNT_EVENT, onCount);
    return () => window.removeEventListener(ADMIN_JOBS_COUNT_EVENT, onCount);
  }, []);

  if (count < 1) return null;

  return (
    <button
      type="button"
      data-testid="admin-jobs-button"
      onClick={() => openAdminJobs()}
      aria-label={count === 1 ? 'Jobs to do, 1 waiting' : `Jobs to do, ${count} waiting`}
      className="inline-flex items-center gap-1.5 border-0 cursor-pointer whitespace-nowrap rounded-xl px-3 py-1.5 mr-2 text-xs font-bold bg-indigo-50 hover:bg-indigo-100 text-indigo-700 transition-colors duration-150 active:translate-y-px focus:outline-none focus-visible:ring-2 focus-visible:ring-indigo-500">
      Jobs
      <span className="inline-flex items-center justify-center min-w-[18px] h-[18px] px-1 rounded-full bg-indigo-600 text-white text-[11px] leading-none">
        {count}
      </span>
    </button>
  );
}

export default AdminJobsButton;
